'use strict';

var mapDirectiveCtrl = ['$state', 'NgMap', function ($state, NgMap) {
    var _this = this;

}];

module.exports = function (NgMap, $timeout) {
    return {
        restrict: 'E',
        scope: {
            items: '=',
            initMap: '='
        },
        controller: mapDirectiveCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/mapDirective.html',
        link: function (scope) {
            var mapInit = false;
            var markers = [];
            var bounds = new google.maps.LatLngBounds();

            scope.apiKey = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyB2qCMNBGF2_-S5gTVHnA7K76nLB8VNYgg';

            function parseItems(items) {
                return items.map(function (item) {
                    for (var id in item.payload) {
                        if (item.payload[id].type === 'geo' && item.payload[id].value && item.payload[id].value.coords) {
                            return { "coords": new google.maps.LatLng(item.payload[id].value.coords.latitude, item.payload[id].value.coords.longitude), "title": item._createdAt.substr(0, 19) + " " + item.member.firstName + " " + item.member.lastName };
                        }
                    }
                }).filter(function(coords) {
                    return !!coords;
                });

            }

            function setBounds(bound, positions) {
                positions.forEach(function (position) {
                    bounds.extend(position.coords);
                });
            }

            function setMarkers(map, positions) {
                if (markers.length) {
                    markers.forEach(function (marker) {
                        marker.setMap(null);
                    });
                }

                positions.forEach(function (position) {
                    markers.push(new google.maps.Marker({
                        position: position.coords, title: position.title,
                        map: map,
                        draggable: false,
                        animation: google.maps.Animation.DROP
                    }));
                });
            }

            function resetMap() {
                NgMap.initMap('mapa');
                NgMap.getMap('mapa').then(function (map) {
                    scope.map = map;
                    map.setCenter(bounds.getCenter());
                    setMarkers(map, scope.positions);
                    scope.map.setZoom(10);
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            }

            scope.positions = parseItems(scope.ctrl.items);
            setBounds(bounds, scope.positions);
            var debounce;
            scope.$on('resetMap', function (event, showMap, items) {
                if (showMap) {
                    if (!mapInit) {
                        $timeout(function () {
                            resetMap();
                            mapInit = true;
                        }, 500);
                    } else {
                        if(items)
                            scope.ctrl.items=items;
                        scope.positions = parseItems(scope.ctrl.items);
                        setBounds(bounds, scope.positions);                        
                        setMarkers(scope.map, scope.positions);
                        scope.map.setCenter(bounds.getCenter());
                    }
                } else {
                    setMarkers(null, scope.positions);
                    
                }
            });



        }
    };
};
